import { render, staticRenderFns } from "./DashboardDoctor.vue?vue&type=template&id=7e8f3269&scoped=true&"
import script from "./DashboardDoctor.vue?vue&type=script&lang=js&"
export * from "./DashboardDoctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8f3269",
  null
  
)

export default component.exports